import React from "react";

import {
  makeStyles,
  CardContent,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import clsx from "clsx";

import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import { ReactComponent as SplitwiseIcon } from "../assets/splitwise_icon.svg";
import { ReactComponent as VenmoIcon } from "../assets/venmo_icon.svg";
import { formatPrice } from "../util";

// semi duplicated from the checkout page

const useCardStyles = makeStyles((theme) => ({
  card: {
    borderRadius: 10,
    borderStyle: "solid",
    borderWidth: 3,
    borderColor: "#00000000",
    height: "100%",
    backgroundColor: "white",

    maxWidth: 350,
    borderColor: theme.palette.primary.light,
  },
  center: {
    margin: "auto",
  },
  left: {
    marginLeft: "auto",
  },
  selectedIcon: {
    color: theme.palette.primary.main,
  },
  price: {
    fontSize: "1.5rem",
  },
}));

export default ({
  type,
  Icon,
  monthlyPrice,
  numAccounts = 1,
  selected,
  onSelect,
  children,
  left,
  action,
}) => {
  const classes = useCardStyles();
  const matches = useMediaQuery("(max-width:720px)");

  return (
    <Grid item xs={12} sm={6}>
      <div
        onClick={onSelect}
        className={clsx(
          classes.card,
          selected && classes.selected,
          matches && classes.center,
          left && !matches && classes.left
        )}
      >
        <CardContent>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ paddingRight: 10 }}>
              <Icon />
            </div>
            <Typography
              variant="h5"
              style={{ textTransform: "capitalize", fontWeight: 600 }}
            >
              {type}
            </Typography>
          </div>
          <p style={{ textAlign: "center", marginTop: 20 }}>
            <span className={classes.price}>
              {monthlyPrice ? formatPrice(monthlyPrice) : "Free during beta"}
            </span>
            {monthlyPrice && <span className={classes.interval}>/ month</span>}
          </p>
          <List>
            <ListItem>
              <ListItemIcon>
                <AccountBalanceIcon />
              </ListItemIcon>
              {numAccounts} account{numAccounts && numAccounts > 1 && "s"}
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <SplitwiseIcon height={22} />
              </ListItemIcon>
              Send to Splitwise
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <VenmoIcon height={22} />
              </ListItemIcon>
              Send to Venmo
            </ListItem>
            {children}
          </List>
          {action && (
            <div style={{ textAlign: "center", marginTop: 10 }}>{action}</div>
          )}
        </CardContent>
      </div>
    </Grid>
  );
};
